import React from "react";
import get from "lodash/get";
import findIndex from "lodash/findIndex";
import { trackEventCustom } from "~/tools/analytics/googleAnalytics";
import pageStore from "~/redux/page/store";

export default function trayEvents(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.googleAnalyticsId = get( window, "settings.analytics.googleAnalyticsId");
      this.page = pageStore.getState();
      this.lazyLoadFlag = (this.page && get(this.page, "data.modulesCount") < 5) ? false : (this.props.lazyLoad === undefined ? true : this.props.lazyLoad)
    }
    trackTrayEvent = (item, i, pos = NaN) => {
      if (this.googleAnalyticsId) {
        const layouts = get(this.page, "data.layouts"), trayId = get(this.props, "data.id");
        const trayElement = (isFinite(pos) && pos > -1) ? pos : findIndex(layouts, layoutItem => layoutItem.id === trayId) + 1;
        const track = {
          pageName: get(this.page, "data.title"), trayName: get(this.props, "data.title") || get(this.props, "trayTitle"),
          itemName: get(item, "gist.title"), trayPos: trayElement || pos || 1,
          itemPos: i + 1
        };
        if ( track["itemName"] && track["itemPos"] && track["pageName"] && track["trayName"] && track["trayPos"])
          trackEventCustom(track["trayName"], track);
        }
    };
    render() {
      return <WrappedComponent {...this.props} trackTrayEvent={this.trackTrayEvent} lazyLoad={this.lazyLoadFlag}/>;
    }
  };
}